import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedFilterUpdatesService {

  constructor() { }

  private filtersSubject = new BehaviorSubject<any>({});
  filters$ = this.filtersSubject.asObservable();

  setFilters(filters: any) {
    this.filtersSubject.next(filters);
  }

  getCurrentFilters(): any {
    return this.filtersSubject.getValue();
  }
}
